export default "__VITE_ASSET__3ztkNyF7__"